module.exports = __webpack_public_path__ + "img/188.d988c8ba.jpg";